import { LWTApiClient } from '@/infrastructures/api/LWTApi';
import { TJwtResponse } from '@/types/responses/login/Login';

const CONCIERGE_LOGIN_PATH = '/concierges/login';
const apiClient = new LWTApiClient({});

export class ConciergeLoginApi {
  static post = async (data: TConciergeLoginRequestBody) => {
    return apiClient.post<TJwtResponse>(CONCIERGE_LOGIN_PATH, data);
  };
}

type TConciergeLoginRequestBody = {
  data: {
    accountName: string;
    password: string;
  };
};
